import { Component } from '@angular/core';

@Component({
  selector: 'oes-theme-cb',
  templateUrl: './cb.component.html',
  styleUrls: ['./cb.component.scss']
})
export class CbComponent {

  constructor() { }

}
